var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light text-center py-2 py-md-3 d-none d-lg-block"},[_c('p',{staticClass:"m-0 f-13"},[_vm._v("© Copyright "+_vm._s(_vm.year))])])}
var staticRenderFns = []

export { render, staticRenderFns }